import type { SnippetBodyFormat } from '../../types/snippetBodyFormat.ts';
import type { SnippetProduct } from '../../types/snippetProduct.ts';

export class SnippetError extends Error {
	statusCode?: number;

	constructor(message: string) {
		super(`Snippet error: ${message}`);
	}
}

const BODY_TOO_LARGE_PATTERN = /body must be \d+\s*KB or less/i;

/**
 * Returns true when the error is a 400 SnippetError caused by the template body exceeding the size limit.
 */
export const isBodyTooLargeError = (err: unknown): boolean =>
	err instanceof SnippetError && err.statusCode === 400 && BODY_TOO_LARGE_PATTERN.test(err.message);

/** Payload for creating or updating a snippet */
export type CreateSnippetPayload = {
	name: string;
	body: string;
	bodyFormat: SnippetBodyFormat;
	product: SnippetProduct;
	description?: string;
};

export type UpdateSnippetPayload = {
	name: string;
	body: string;
	description?: string;
};

export type SnippetFavoriteData = {
	userId: string;
	snippetIds: string[]; // Array of snippet ARIs
};
